import { PropsWithChildren } from "react";

type Props = PropsWithChildren;
export function Col({ children }: Props) {
  return <div className={"flex flex-col space-y-4"}>{children ?? null}</div>;
}
